// composables/useViewportHeight.ts
import { ref, onMounted, onUnmounted } from 'vue'

export function useViewportHeight() {
  const viewportHeight = ref<number>(window.innerHeight)

  const updateHeight = () => {
    viewportHeight.value = window.innerHeight
  }

  onMounted(() => {
    updateHeight()
    window.addEventListener('resize', updateHeight)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', updateHeight)
  })

  return {
    viewportHeight
  }
}
